import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sidebarConstants } from '../constants/sidebar.constants';
import { organizationActions } from '../actions';

function useSidebarHook({}) {
    const dispatch = useDispatch();
    const default_modes = sidebarConstants.DEFAULT_MODES;
    const { selected_organization, selected_tab } = useSelector(state => state.sidebar);

    useEffect(() => {

        // Notifications is selected by default
        if(selected_organization === default_modes[3]){
            
        } else if(selected_organization){
            dispatch(organizationActions.getWorkspaces(selected_organization));
        }
    }, []);
    
    useEffect(() => {
        if(selected_organization && selected_organization !== 0){

            // Notifications
            if(selected_organization === default_modes[3]){
        
            } else {
            if(default_modes.indexOf(selected_organization) === -1){
                dispatch(organizationActions.getOrganizationDetail(selected_organization))
            }
            
            dispatch(organizationActions.getWorkspaces(selected_organization));
            }

        }
    }, [selected_organization]);


    useEffect(() => {
        // Notifications
        if(selected_tab === default_modes[3]){

        } else {
            if(selected_tab && selected_tab !== default_modes[2]){
            dispatch(organizationActions.getWorkspaces(selected_tab));
            }
        }
    }, [selected_tab]);

    return {}
      
}

export default useSidebarHook;